export default __webpack_public_path__ + "static/media/235.8161e3c1.gif";